import FJRecorderManager from "../../core/FJRecorderManager";
import FJUtil from "../../util/FJUtil";
import FJActionConstant from "../../constant/FJActionConstant";
import {FJMediaAction, FJModalAction} from "./FJRoot.action";
import FJLocalStore from "../../store/FJLocalStore";
import FJConfig from "../../config/FJConfig";

let FJRecordingAction = (function () {

  let isAddListener = false; // 录屏录像是否添加监听事件
  let videoBlob = null; // 录屏录像后的视频文件
  let hasAudio = false; // 录制过程中是否使用了音轨
  let isRecordingClose = false; // 是否在正在录像时关闭 录像弹窗
  console.log(hasAudio, isRecordingClose);

  async function openRecordScreen () {
    videoBlob = null;
    try {
      // 调起录屏
      /**
       * 录制屏幕
       * @param {boolean} microphone 是否启用麦克风
       * @param {boolean} systemAudio 是否启用设备声音
       * @param {Object} options 其他选项
       * @param {Function} streamHandler 额外媒体流handler, 应当返回一个处理后的MediaStream
       * @returns {Promise<Blob>}
       */
      videoBlob = await FJRecorderManager.recordScreen(false, true, {}, (stream) => {
        let audioTracks = stream.getAudioTracks();
        hasAudio = !!audioTracks.length;
        return stream;
      });
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * @description 下载录屏录像的视频
   */
  function downloadVideo(name) {
    FJUtil.downloadFromRecord(videoBlob, 'video', name);
  }

  return {

    /**
     * @description 点击录屏按钮
     * @returns {Function}
     */
    startRecordScreenAction: function () {
      return (dispatch) => {
        dispatch(this.startRecordingAction());

        FJUtil.ealog('app_record click', {
          categary: 'screen'
        });
      }
    },

    /**
     * @description 调起录屏前的判断
     * @returns {Function}
     */
    startRecordingAction: function () {
      return (dispatch, getState) => {
        const state = getState();
        const recording = state.recording;
        if (!recording.isScreenRecording) {
          dispatch(this.setScreenRecordingTypeAction(1)); // 会进行录屏
          if (!isAddListener)
            dispatch(this.addVideoRecordingListener());
          openRecordScreen().then(); // 写法问题
        }
      }
    },

    /**
     * @desc 添加录屏录像监听
     * @returns {Function}
     */
    addVideoRecordingListener: function () {

      isAddListener = true;
      return (dispatch, getState) => {
        FJRecorderManager.addStateListener((state) => {
          const states = getState();
          const recording = states.recording;
          switch (state) {
            case FJRecorderManager.state.START:

              if (recording.screenRecordingType === 1) { // 录屏
                dispatch(this.setScreenRecordingStateAction(true)); // 设置当前正在录屏
                dispatch(this.setCurrentStageAction(5));
                dispatch(FJModalAction.setIsShowScreenRecordingModalAction(true)); // 设置显示的倒计时

              } else if (recording.screenRecordingType === 2) { // 录像

              }

              break;
            case FJRecorderManager.state.STOP:
              if (recording.screenRecordingType === 1) { // 录屏
                dispatch(this.setScreenRecordingStateAction(false)); // 设置当前未在录屏
                dispatch(FJModalAction.setIsShowScreenRecordingModalAction(false)); // 隐藏显示的倒计时
                dispatch(this.setCurrentStageAction(8));
                dispatch(this.completeScreenRecording()) // 完成录屏


              } else if (recording.screenRecordingType === 2) { // 录像
                if (videoBlob && !isRecordingClose) {
                  dispatch(this.setCurrentStageAction(7));
                  dispatch(this.completeRecordingWebCam()) // 完成录像
                }
              }

              break;
          }
        });
      }
    },

    /**
     * @description 设置当前录像录像类型
     * @param data {Number} 1录屏， 2录像
     * @returns {{data: *, type: string}}
     */
    setScreenRecordingTypeAction: function (data) {
      return {
        type: FJActionConstant.CHANGE_SCREEN_RECORDING_TYPE,
        data
      }
    },

    /**
     * @description 设置录屏录像步骤
     * @param data {Number} 0:初始化状态 1：显示录像内容， 2：拍照倒计时中, 3:录像倒计时, 4:录像中，5:录屏中， 5：拍照预览， 6：录像预览, 7:录屏预览
     * @returns {{data: *, type: string}}
     */
    setCurrentStageAction: function (data) {
      return {
        type: FJActionConstant.SET_CURRENT_STAGE,
        data
      }
    },

    /**
     * @description 设置当前是否正在录屏
     * @param data {boolean}
     * @returns {{data: *, type: string}}
     */
    setScreenRecordingStateAction: function (data) {
      return {
        type: FJActionConstant.SET_SCREEN_RECORDING_STATE,
        data
      }
    },

    /**
     * @description 完成录屏
     * @returns {Function}
     */
    completeScreenRecording: function () {
      return (dispatch) => {

        dispatch(FJModalAction.setIsShowRecordingModalAction(true));
        let videoSrc = URL.createObjectURL(videoBlob);
        dispatch(this.updateVideoSourceAction(videoSrc));
      }
    },

    /**
     * @description 更新录屏后的videoSrc
     * @param videoSrc
     * @returns {{data: *, type: string}}
     */
    updateVideoSourceAction: function (videoSrc) {
      return {
        type: FJActionConstant.UPDATE_VIDEO_SOURCE,
        data: videoSrc
      };
    },

    /**
     * @description 用户点击退出
     * @param callback
     * @returns {Function}
     */
    onCancelAction: function (callback) {
      return (dispatch, getState) => {
        // currentStage: 0:初始化状态, 1：显示录像内容， 2：拍照倒计时中, 3:录像倒计时, 4:录像中，5:录屏中， 6：拍照预览， 7：录像预览, 8:录屏预览
        const states = getState();
        const recording = states.recording;
        switch (recording.currentStage) {
          case 1:
          case 2:
          case 3:
            callback();
            dispatch(this.setCurrentStageAction(1));
            this.endRecordingScreenAction();
            dispatch(this.clearAction());
            break;
          case 4:
            isRecordingClose = true;
            dispatch(this.showCloseRecordScreenConfirmModalAction(callback, 3)); // 正在录像 点击关闭显示的 关闭确认弹窗
            break;
          case 5:
            break;
          case 6:
            dispatch(this.showCloseRecordScreenConfirmModalAction(callback, 2)); // 在 截屏 预览时 点击关闭显示的 关闭确认弹窗
            break;
          case 7:
          case 8:
            dispatch(this.showCloseRecordScreenConfirmModalAction(callback, 1)); // 在 Record Screen 预览时 点击关闭显示的 关闭确认弹窗
            break;
          default:
        }
      }
    },

    /**
     * @description 用户点击use
     * @param callback
     * @param imgUrl
     * @param duration
     * @returns {Function}
     */
    onSubmitAction: function (callback, imgUrl, duration) {
      return (dispatch, getState) => {
        const state = getState();
        const recording = state.recording;
        if (recording.currentStage === 6) {
          callback(); // 关闭弹窗
          dispatch(this.usePhotoAction(imgUrl));
          dispatch(this.clearAction());
        } else {
          callback(); // 关闭弹窗
          if (duration < FJConfig.minLimitTime) {
            dispatch(this.showVideoDurationShortModalAction());
          } else {
            let name;
            if (recording.currentStage === 8) {
              name = FJConfig.ScreenRecordingName
            } else if (recording.currentStage === 7) {
              name = FJConfig.CameraRecordingName
            }
            videoBlob.name = name + '.webm';
            let list = [videoBlob];
            dispatch(FJMediaAction.addLocalMediaAction(list));
            downloadVideo(name);
          }

          if (recording.currentStage === 8) {
            FJUtil.ealog('timeline_record screen use', {
              length: FJUtil.formatTime(duration),
              audio: hasAudio,
            })
          } else if (recording.currentStage === 7) {
            FJUtil.ealog('timeline_record webcam use', {
              length: FJUtil.formatTime(duration),
              audio: hasAudio,
              photoOrVideo: 'video'
            })
          }

          dispatch(this.clearAction());
        }
      }
    },

    /**
     * @description 清除录屏完成后的一些信息
     * @returns {Function}
     */
    clearAction: function () {
      return (dispatch) => {
        videoBlob = null;
        dispatch(this.updateVideoSourceAction(''));
      }
    },

    /**
     * @description 预览的时候点击重新录屏或者录像
     * @param callback
     * @returns {Function}
     */
    onReRecordAction: function (callback) {
      return (dispatch) => {
        dispatch(this.showConfirmReRecordingAction(callback)); // 在 Record Screen 预览时 显示 重新录屏确认弹窗
      }
    },

    /**
     * @description 点击录像按钮
     * @returns {Function}
     */
    startRecordWebCamAction: function () {
      return (dispatch) => {
        dispatch(this.setCurrentStageAction(1));
        dispatch(this.openVideoTapeAction());

        FJUtil.ealog('app_record click', {
          categary: 'webcam'
        });
      }
    },

    /**
     * @desc 进行录像 的操作
     * @returns {Function}
     */
    openVideoTapeAction: function () {
      return async (dispatch) => {
        dispatch(this.setScreenRecordingTypeAction(2)); // 会进行录像
        videoBlob = null;
        isRecordingClose = false;
        if (!isAddListener)
          dispatch(this.addVideoRecordingListener());

        dispatch(FJModalAction.setIsShowLoadingModalAction(true));

        let isCanOpenRecording = true;
        // 点击时添加全局提示，全局提示超时时间（15s）
        let checkPermissionTimeOut = setTimeout(() => {
          FJRecorderManager.stop();
          dispatch(FJModalAction.setIsShowLoadingModalAction(false));
          dispatch(this.showRecordWebCamAnomalousModalAction());
          isCanOpenRecording = false;
          clearTimeout(checkPermissionTimeOut);
        }, 15000);

        try {
          // console.log('调出录像')
          // 调出录像
          /**
           * 录制网络摄像头
           * @param {boolean} microphone 是否启用麦克风
           * @param {Object} options 其他选项
           * @param {Function} streamHandler 额外媒体流handler, 应当返回一个处理后的MediaStream
           * @returns {Promise<Blob>}
           */
          videoBlob = await FJRecorderManager.recordWebcam(true, {}, (stream) => {

            // 询问录像权限时 超过15s 还没点击允许，然后再点击允许，不允许再录像。
            if (!isCanOpenRecording) {
              stream.getTracks().forEach(track=>track.stop());
              return stream;
            }

            dispatch(FJModalAction.setIsShowLoadingModalAction(false));

            clearTimeout(checkPermissionTimeOut);

            dispatch(FJModalAction.setIsShowRecordingModalAction(true));

            dispatch(this.getEquipmentInfoAction()); // 更新录像的设备信息
            dispatch({type: FJActionConstant.SET_VIDEO_TAPE_SRC, data: stream}); // 更新摄像头内容
            let audioTracks = stream.getAudioTracks();
            hasAudio = !!audioTracks.length;
            return stream;
          });
        } catch (e) {
          // console.log('录像异常', e);
          clearTimeout(checkPermissionTimeOut);
          dispatch(FJModalAction.setIsShowLoadingModalAction(false));
          dispatch(this.showRecordWebCamAnomalousModalAction());
        }
      }
    },

    /**
     * @description 获取录像设备的信息
     * @returns {Function}
     */
    getEquipmentInfoAction: function () {
      return async (dispatch) => {
        let cameraList = await FJRecorderManager.getVideoInput();
        let microphoneList = await FJRecorderManager.getAudioInput();
        let cameraActiveIndex = 0;
        let microphoneActiveIndex = 0;
        cameraList.forEach((item, index) => {
          if (item.deviceId === 'default') {
            cameraActiveIndex = index;
          }
        });
        microphoneList.forEach((item, index) => {
          if (item.deviceId === 'default') {
            microphoneActiveIndex = index;
          }
        });
        dispatch({type: FJActionConstant.SET_CAMERA_LIST, data: {list: cameraList, index: cameraActiveIndex}});
        dispatch({type: FJActionConstant.SET_MICROPHONE_LIST, data: {list: microphoneList, index: microphoneActiveIndex}});
      };
    },

    /**
     * @description 修改录像时的配置信息
     * @param type 配置类型，
     * @param index 配置的index
     */
    changeRecordingConfigAction: function (type, index) {
      return async (dispatch, getState) => {
        const state = getState();
        const recording = state.recording;

        if (recording[type] === index) { // 如果修改本身 返回
          return
        }

        dispatch({type: FJActionConstant.CHANGE_RECORDING_CONFIG, data: {type: type, index: index}});

        FJRecorderManager.stop();
        videoBlob = null;
        try {
          // console.log('切换录像')
          // 调出录像
          /**
           * 录制网络摄像头
           * @param {boolean} microphone 是否启用麦克风
           * @param {Object} options 其他选项
           * @param {Function} streamHandler 额外媒体流handler, 应当返回一个处理后的MediaStream
           * @returns {Promise<Blob>}
           */
          let options = {
            videoDeviceId: recording.cameraList[recording.cameraActiveIndex].deviceId,
            audioDeviceId: recording.microphoneList[recording.microphoneActiveIndex].deviceId,
          };
          let blob = await FJRecorderManager.recordWebcam(true, options, (stream) => {
            dispatch({type: FJActionConstant.SET_VIDEO_TAPE_SRC, data: stream}); // 更新摄像头内容
            return stream;
          });
          if (blob) {
            videoBlob = blob;
          }
        } catch (e) {
          // console.log('切换录像异常', e);
        }
      }
    },

    /**
     * @description 完成录像
     * @returns {Function}
     */
    completeRecordingWebCam: function () {
      return (dispatch) => {
        let videoSrc = URL.createObjectURL(videoBlob);
        dispatch(this.updateVideoSourceAction(videoSrc));
      }
    },

    /**
     * @description 使用图片
     * @param screenShotImage
     * @returns {Function}
     */
    usePhotoAction: function (screenShotImage) {
      return (dispatch) => {
        dispatch(FJModalAction.setIsShowRecordingModalAction(false));
        let name = "Photo with FlexClip.png";
        let file = FJUtil.dataURLtoFile(screenShotImage, name);
        dispatch(FJMediaAction.addLocalMediaAction([file]));
        FJUtil.downloadFromRecord(file, 'image', file.name);

        FJUtil.ealog('timeline_record webcam use', {
          length: 0,
          audio: false,
          photoOrVideo: 'photo'
        })
      };
    },


    /**
     * @desc 在 Record Screen 预览时 点击关闭显示的 关闭确认弹窗
     * @param callback
     * @param type 1:video 2:photo，3 录像时
     * @returns {Function}
     */
    showCloseRecordScreenConfirmModalAction: function (callback, type) {
      return (dispatch) => {
        let headerText = type === 1 ? FJLocalStore._('closing-window') : FJLocalStore._('closing-window');
        let bodyText = type === 1 ? FJLocalStore._('recorded-close') : FJLocalStore._('photo-close');
        let data = {
          headerText,
          bodyText,
          onCancel: (hide)=> {
            hide();
            callback('cancel')
          },
          onSubmit: (hide) => {
            if (type === 3) {
              this.endRecordingScreenAction();
            }
            dispatch(this.setCurrentStageAction(1));
            callback();
            hide();
            dispatch(this.clearAction());
          },
          cancelType: 'cancel',
          submitText: FJLocalStore._('close')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      };
    },

    /**
     * @description 在 Record Screen 预览时 显示 重新录屏确认弹窗
     * @param callback
     * @returns {Function}
     */
    showConfirmReRecordingAction: function (callback) {
      return (dispatch, getState) => {

        // currentStage: 0:初始化状态, 1：显示录像内容， 2：拍照倒计时中, 3:录像倒计时, 4:录像中，5:录屏中， 6：拍照预览， 7：录像预览, 8:录屏预览
        const state = getState();
        const recording = state.recording;
        let headerText;
        let bodyText;
        let submitText = FJLocalStore._('re-record');
        switch (recording.currentStage) {
          case 6:
            headerText = FJLocalStore._('re-take-title');
            bodyText = FJLocalStore._('photo-re-take');
            submitText = FJLocalStore._('re-photograph');
            break;
          case 7:
          case 8:
            headerText = FJLocalStore._('re-recording-title') ;
            bodyText = FJLocalStore._('re-recording-content');
            break;
          default:
        }
        let data = {
          headerText,
          bodyText,
          onCancel: (hide) => {
            hide();
            callback('cancel');
          },
          onSubmit: (hide) => {
            callback();
            hide();
            dispatch(this.setCurrentStageAction(1));
            switch (recording.currentStage) {
              case 6:
                dispatch(this.startRecordWebCamAction()); // 录像
                break;
              case 7:
                dispatch(this.startRecordWebCamAction());  // 录像
                break;
              case 8:
                dispatch(this.startRecordScreenAction()); // 录屏
                break;
              default:
            }
          },
          cancelType: 'cancel',
          submitText: submitText,
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      }
    },

    /**
     * @desc 显示录屏录像的视频时常小于最小时常的弹窗
     * @returns {Function}
     */
    showVideoDurationShortModalAction: function () {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('video-duration-short'),
          bodyText: FJLocalStore._('video-duration-short-content').replace(/xxx/g, FJConfig.minLimitTime),
          onCancel: null,
          onSubmit: null,
          cancelType: 'cancel',
          submitText: FJLocalStore._('ok')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      };
    },

    /**
     * @description 调出录像异常的弹窗
     * @returns {Function}
     */
    showRecordWebCamAnomalousModalAction: function () {
      return (dispatch) => {
        let data = {
          headerText: FJLocalStore._('get-permission-record-title'),
          bodyText: FJLocalStore._('get-permission-record-content'),
          onCancel: null,
          onSubmit: null,
          hasCancel: false,
          cancelType: 'cancel',
          submitText: FJLocalStore._('got-it')
        };
        dispatch(FJModalAction.showConfirmModalAction(data));
      };
    },

    /**
     * @description 结束录屏录像
     */
    endRecordingScreenAction: function () {
      FJRecorderManager.stop();
    },

    /**
     * @description 录像开始
     */
    startVideoBeginsAction: function () {
      return (dispatch) => {
        FJRecorderManager.begin();
        dispatch(this.setCurrentStageAction(4));
      }
    }
  }
})();

export default FJRecordingAction;
